/**
 * Created by ronmarsiano on 08/01/2019.
 */
mainApp.component('planSiteUsage', {
    templateUrl: '/public/components/plan-site-usage.component.html',
    bindings: {
        zoneList: '=',
        zoneMap: '=',
        componentConfig: '='
    },
    controller: function ($scope,$timeout,$state,GeneralUtilsService){
        var ctrl = this;
        var errorMessage;

        ctrl.userNotifiedForError = false;

        ctrl.newSiteService = {
            id: 'newSite',

            getExpiration: function() {
                if(!ctrl.newSiteUsage) {
                    return new Date().getTime();
                }
                return ctrl.newSiteUsage.expiration;
            },

            setExpiration: function(expiration) {
               ctrl.newSiteUsage.expiration = expiration;
            }
        };


        function addDeleteFunction() {
            ctrl.siteUsageConfig.specialActions.push(
                {"func":function(selectedItems, tableConfig) {
                    function canDelete() {
                        var sitesIds = selectedItems.map(item => item.site.id).filter(id => id != -1);
                        if(sitesIds.length != 0) {
                            $scope.$root.showNotification('error', 'Deleting license with allocated site is forbidden. Assign another license, or delete site first.', 'Error', true, true);
                            return false;
                        } else {
                            var licenseIds = selectedItems.map(item => item.protoId);
                            var usagesThatHadSidePreviously = $scope.$ctrl.siteUsageOrigItems.filter(usage => usage.site.id > 0).filter(usage => licenseIds.includes(usage.id));
                            if(usagesThatHadSidePreviously.length != 0){
                                $scope.$root.showNotification('error', 'Deleting license that previously had allocated site is forbidden. Save your other changes first.', 'Error', true, true);
                                return false;
                            }
                        }
                        return true;
                    };
                    if(!canDelete()){
                        return;
                    }
                    var deletedItems = [];
                    selectedItems.forEach(function(item) {
                        for(var i = 0 ; i < ctrl.siteUsageConfig.items.length ; i++){
                            var siteUsage = ctrl.siteUsageConfig.items[i];
                            if(siteUsage.id === item.id){
                                var attribute = (siteUsage.siteLifeCycleStatus != null) ? siteUsage.siteLifeCycleStatus.toLowerCase() : null;
                                ctrl.siteUsageConfig.items.splice(i,1);
                                ctrl.componentConfig.planStats.totalStats.total--;
                                if (attribute != null)
                                    ctrl.componentConfig.planStats.totalStats[attribute]--;

                                if (siteUsage.isAllocated){
                                    ctrl.componentConfig.planStats.siteConfigured--;
                                    ctrl.componentConfig.planStats.usedStats.total--;
                                    if (attribute != null)
                                        ctrl.componentConfig.planStats.usedStats[attribute]--;
                                }else{
                                    ctrl.componentConfig.planStats.unusedStats.total--;
                                    if (attribute != null)
                                        ctrl.componentConfig.planStats.unusedStats[attribute]--;
                                }

                                if(siteUsage.id > 0){
                                    deletedItems.push(item);
                                }
                                break;
                            }
                        }
                    });
                    ctrl.componentConfig.itemsToDelete = deletedItems;
                },"icon":"delete",tooltip:"Delete"}
            );
        }


        /**
         * return the site by the site id
         * @param siteId
         * @returns {*}
         */
        function getSiteById(siteId) {
            var ret;
            if(ctrl.siteUsageConfig && ctrl.siteUsageConfig.sites){
                ctrl.siteUsageConfig.sites.forEach(function (site) {
                    if(site.id == siteId)
                        ret = site;
                });
            }
            return ret;
        }


        /**
         * return true if the configuration is valid and false (with error messages )
         * if not
         * @returns {boolean}
         */
        function isValid() {
            if(ctrl.componentConfig.plan.currentLifeCycle != 'Commercial') {
                return true;
            }
            if(!noDuplicateSitesOnSiteUsage()){
                globalNotify('error', errorMessage);
                $scope.$root.errors['siteUsageTableErrors'] = errorMessage;
                return false;
            }
            if(!siteUsageBandwidthValidation()){
                globalNotify('error', errorMessage);
                $scope.$root.errors['siteUsageTableErrors'] = errorMessage;
                return false;
            }
            else{
                delete $scope.$root.errors['siteUsageTableErrors'];
                ctrl.userNotifiedForError = false;
            }
            return true;
        }

        function globalNotify(type, errorMessage) {
            if(ctrl.userNotifiedForError == false) {
                $scope.$root.showNotification('error', errorMessage);
                ctrl.userNotifiedForError = true;
            }
        }

        /**
         * validates that the given value is constructed only on
         * numbers
         * @param value
         * @returns {boolean}
         */
        function onlyNumbers(value) {
                var pattern = /^[0-9]{1,20}$/;
                return pattern.test(value);
        }


        /**
         * validate that the bandwidth is a positive number
         * @returns {boolean}
         */
        function siteUsageBandwidthValidation() {
            var isValid = true;

            if(ctrl.siteUsageConfig && ctrl.siteUsageConfig.items){
                ctrl.siteUsageConfig.items.forEach(function (siteUsage) {
                    if(!bandwidthValidation(siteUsage.maxBandwidth)){
                        isValid = false;
                    }
                })
            }
            if(!isValid){
                getNotValidBandwidthErrorMessage();
            }
            return isValid;
        }


        /**
         * set the error message to the bandwidth error message
         */
        function getNotValidBandwidthErrorMessage() {
            errorMessage = 'Bandwidth should be set to a positive number';
        }


        /**
         * validates that there is no duplication on sites on the site usage
         */
        function noDuplicateSitesOnSiteUsage() {
            var siteIds = [];
            var duplicatedSites = [];
            var duplicate = false;
            if(ctrl.siteUsageConfig && ctrl.siteUsageConfig.items){
                ctrl.siteUsageConfig.items.forEach(function (siteUsage) {
                    if(siteUsage.site.id!= -1 && siteIds.indexOf(siteUsage.site.id)>=0){
                        duplicatedSites.push(siteUsage.site);
                        duplicate = true;
                    }
                    else{
                        siteIds.push(siteUsage.site.id);
                    }
                });
            }

            if(duplicate){
                noDuplicateErrorMessage(duplicatedSites)
            }

            /*
             * if duplicate = true  --> should return false
             *    duplicate = false --> should return true
             */
            return !duplicate;
        }


        /**
         * proper the error message for duplicated sites on site usages
         * @param duplicatedSites
         */
        function noDuplicateErrorMessage(duplicatedSites) {
            errorMessage = '';

            duplicatedSites.forEach(function (site) {
                errorMessage = errorMessage + site.name + ' ,';
            });
            // remove ','
            errorMessage = errorMessage.substring(0, errorMessage.length - 1);
            errorMessage = errorMessage + 'should be allocated once';
        }


        function autoPopulateSiteUsages(items,allocatedSiteUsages) {
            var autoFill = 0;

            // ids of sites we have already allocated
            var allocatedSitesIds = [];
            // site usage with no sites on
            var siteUsage2Allocate = [];
            allocatedSiteUsages.forEach(function (siteUsage) {
                if(siteUsage.siteId >= 0){
                    allocatedSitesIds.push(siteUsage.siteId);
                    items.push(siteUsage);
                }
                else{
                    siteUsage2Allocate.push(siteUsage);
                }

            });

            // site ids to allocate
            var siteIds2Allocate = [];
            ctrl.siteUsageConfig.sites.forEach(function (site){
                if(allocatedSitesIds.indexOf(site.id)<0){
                    siteIds2Allocate.push(site.id);
                }
            });

            siteIds2Allocate.forEach(function (id2Allocate) {
                var site = getSiteById(id2Allocate);

                if(siteUsage2Allocate.length >0){
                    var siteUsage = siteUsage2Allocate.shift();
                    siteUsage.siteId = id2Allocate;
                    if(id2Allocate != -1 && site){
                        siteUsage.region = calcZone(site);
                    }
                    items.push(siteUsage);
                }else{
                    if(id2Allocate != -1 && site){
                        var tempSiteUsage = { id: GeneralUtilsService.getRandomId(), name: "", siteId: id2Allocate, region: calcZone(site), isAllocated: true};
                        items.push(tempSiteUsage);
                        autoFill++;
                    }
                }
            });

            // push all the rest of the site usages that are defined but not connected to site
            siteUsage2Allocate.forEach(function(siteUsage){
                items.push(siteUsage);
            });

            return autoFill;
        }

        /**
         * Calculate zone for site
         */
        function calcZone(site) {
            for(var zoneKey in ctrl.zoneMap) {
                if (ctrl.zoneMap[zoneKey].includes(site.countryRaw)){
                    return zoneKey;
                }
            }

            return '';
        }

        /**
         * returns true if the component has changes
         * @returns {boolean}
         */
        function hasChanges() {
            return !angular.equals(ctrl.siteUsageConfig.items, ctrl.siteUsageOrigItems);
        }


        /**
         * when we reload the component after saving we would like
         * to reload the table using the usagemodified and items
         * to delete
         */
        function reload() {
            ctrl.siteUsagedatamodified = new Date().getTime();
            ctrl.componentConfig.itemsToDelete = [];
        }


        /**
         * validate that the given maxBandwidth is a valid number
         * @param maxBandwidth
         * @returns {boolean}
         */
        function bandwidthValidation(maxBandwidth) {
            return onlyNumbers(maxBandwidth) && maxBandwidth>-1;
        }


        /**
         * create the table configuration for the site usage component
         */
        function createSiteUsageConfig() {
            ctrl.siteUsageConfig = {
                bandwidthValidation: function (maxBandwidth) {
                    return !bandwidthValidation(maxBandwidth);
                },
                bandwidthErrorMessage: 'Invalid',
                sites: [{id:-1,name:'Unassigned'}],
                siteLifeCycleStatus : ['Trial','Commercial','Lock','Disable'],
                dataURL : function(){
                    if(!ctrl.componentConfig.planId){
                        return null;
                    }
                    else {
                        return "/planSiteUsage?planId=" + ctrl.componentConfig.planId;
                    }
                },
                processData : function(items){
                    var autoFill = 0;
                    if(ctrl.componentConfig.autoPopulate){
                        ctrl.componentConfig.autoPopulate = false;
                        ctrl.siteUsageConfig.items = [];
                        autoFill = autoPopulateSiteUsages(ctrl.siteUsageConfig.items,items);
                        items.splice(0,items.length);
                        ctrl.siteUsageConfig.items.forEach(function (siteUsageElement) {
                            items.push(siteUsageElement);
                        });
                    }
                    items.forEach(function(item){
                        item.lastModifiedTime = moment(GeneralUtilsService.getTimeInMiliseconds(item.lastModified)).calendar();
                        item.site = ctrl.siteUsageConfig.sites.filter(function (site) {
                            return site.id == item.siteId})[0];
                        // set unallocated sites
                        setUnallocatedSite(item);

                        item.expirationService = {
                            id: 'item-' + item.site,
                            getExpiration: function() {
                                return item.currentLifeCycleExpiration;
                            },
                            setExpiration: function(expiration) {
                                item.currentLifeCycleExpiration = expiration;
                            }
                        };
                    });
                    ctrl.siteUsageOrigItems = angular.copy(items);
                    ctrl.componentConfig.planStats.totalStats.total += autoFill;

                    return ctrl.siteUsageConfig.items;
                },
                type : "SiteUsageLimitation",
                selectedItems:[],
                clientSidePaging: true,
                clientSideSearch: true,
                clientSideSort: true,
                searchPredicate: function(item, valueToSearch) {
                    return (item.site?.name?.toLowerCase().includes(valueToSearch));
                },
                titleSearch: true,
                defer:true,
                customButtons : [],
                actions:[],
                changeSite: function(item, prevSiteId){
                    if (item.site.id == prevSiteId)
                        return;

                    var attribute = (item.siteLifeCycleStatus != null) ? item.siteLifeCycleStatus.toLowerCase() : null;
                    if(item.isAllocated && item.site.id == -1 ){
                        ctrl.componentConfig.planStats.usedStats.total--;
                        ctrl.componentConfig.planStats.unusedStats.total++;
                        item.isAllocated = false;
                        if (attribute != null){
                            ctrl.componentConfig.planStats.usedStats[attribute]--;
                            ctrl.componentConfig.planStats.unusedStats[attribute]++;
                        }
                    }else if (prevSiteId == -1 || ((item.site.id == -1) && !item.isAllocated)){
                        ctrl.componentConfig.planStats.usedStats.total++;
                        ctrl.componentConfig.planStats.unusedStats.total--;
                        item.isAllocated = true;
                        if (attribute != null){
                            ctrl.componentConfig.planStats.usedStats[attribute]++;
                            ctrl.componentConfig.planStats.unusedStats[attribute]--;
                        }
                    }
                },
                changeSiteLifeCycleStatus: function(item, oldLifeCycle){
                    if (item.currentLifeCycle == oldLifeCycle)
                        return;

                    updateSiteStatsCounts(item, oldLifeCycle);
                },
                specialActions: [],
                pageSize: 50,
                noSearch:true
            };
        }


        /**
         * update site stats due to life cycle changed
         */
        function updateSiteStatsCounts(item, oldLifeCycle){
            var attribute = item.siteLifeCycleStatus.toLowerCase();

            item.isAllocated ? ctrl.componentConfig.planStats.usedStats[attribute]++ : ctrl.componentConfig.planStats.unusedStats[attribute]++;
            ctrl.componentConfig.planStats.totalStats[attribute]++;

            decreaseRelevantSiteStatsCounts(item, oldLifeCycle);
        }


        /**
         * decrease relevant site stats due to life cycle change
         */
        function decreaseRelevantSiteStatsCounts(item, oldLifeCycle){
            var attribute = oldLifeCycle.toLowerCase();

            item.isAllocated ? ctrl.componentConfig.planStats.usedStats[attribute]-- : ctrl.componentConfig.planStats.unusedStats[attribute]--;
            ctrl.componentConfig.planStats.totalStats[attribute]--;
        }


        /**
         * I extracted the setting of the fields properties outside since it needs the componentConfig but
         * since this property depends on the digest cycle on so does the ng-table I needed to add this property after the
         * componentConfig was populated ( $timeout will suffice ) and added an ng-if to the ng-table - same goes for
         * zone list
         */
        function populateSiteUsageConfigProperties() {
            ctrl.siteUsageConfig.fields = [
                {"label":"Allocated","path":"site.name","template":"<select ng-model='item.site' class='form-control' ng-options='site as site.name for site in tableConfig.sites track by site.id' ng-change='tableConfig.changeSite(item, \"{{item.site.id}}\")'></select>"},
                {"label":"Zone","path":"region","template":"<select ng-model='item.region' class='form-control' ng-options='zone for zone in tableConfig.zoneList' ng-disabled="+!ctrl.componentConfig.isSystemLogin+"></select>"},
                {"label":"Country","path":"country","noSort": "true","template":"<span>{{item.country}}</span>"},
                {"label":"Bandwidth (Mbps)","path":"maxBandwidth","template":"" +
                "<div><span style='display: inline-block;width: 40px;'><input type='text' ng-model='item.maxBandwidth' ng-disabled="+!ctrl.componentConfig.isSystemLogin+" /></span>" +
                "         <div style='display: inline-block;padding-top: 18px;' ng-show=\"tableConfig.bandwidthValidation(item.maxBandwidth)\" data-id=\"tableConfig.bandwidthErrorMessage\" class=\"help-block has-error\"><ul class=\"list-unstyled\"><li><pre >{{tableConfig.bandwidthErrorMessage}}</pre></li></ul></div></div>"},
                {"label":"Life Cycle","path":"siteLifeCycleStatus","template":"<select ng-model='item.siteLifeCycleStatus' ng-change='tableConfig.changeSiteLifeCycleStatus(item, \"{{item.siteLifeCycleStatus}}\")' class='form-control' ng-options='status for status in tableConfig.siteLifeCycleStatus' ng-disabled="+!ctrl.componentConfig.isSystemLogin+"></select>"},
                {"label": "Expiration","path":"currentLifeCycleExpiration","template":"<form-input path='item.currentLifeCycleExpiration' ng-if='item.siteLifeCycleStatus==\"Trial\"'><div id='trialDatePicker'><date-picker-with-indication service='item.expirationService' ng-disabled="+!ctrl.componentConfig.isSystemLogin+"  utc='true' options='tableConfig.datePickerOptions'></date-picker-with-indication></form-input>"},
                {"label":"Modified on","path":"lastTimestamp","template":"<span>{{item.lastModifiedTime}}</span>"},
                {"label":"Modifier","path":"modifier","template":"<span>{{item.modifier}}</span>"}
            ];
            ctrl.siteUsageConfig.zoneList = ctrl.zoneList;
            ctrl.siteUsageConfig.datePickerOptions = ctrl.datePickerOptions;
        }


        /**
         * function to initiate the component
         */
        function init() {
            ctrl.siteUsagedatamodified = false;
            createSiteUsageConfig();
            $timeout(function(){
                ctrl.datePickerOptions = ctrl.componentConfig.datePickerOptions;
                ctrl.componentConfig.getSiteUsageConfig = getSiteUsageConfig;
                ctrl.componentConfig.hasChanges = hasChanges;
                ctrl.componentConfig.reload = reload;
                ctrl.componentConfig.isValid = isValid;
                ctrl.componentConfig.itemsToDelete = [];

                if(ctrl.componentConfig.isSystemLogin){
                    // if system we would like to allow adding site usage license
                    addSiteUsageAddingAbility();
                    // if system we like to allow delete site usage license
                    addDeleteFunction();
                } else {
                    ctrl.siteUsageConfig.actions = null;
                    ctrl.siteUsageConfig.hideCheckboxes =  true;
                }

                populateSitesData();
                ctrl.siteUsagedatamodified = new Date().getTime();
                populateSiteUsageConfigProperties();


            }, 1);
        }


        /**
         * adding the ability to add site usage limitation on the UI
         */
        function addSiteUsageAddingAbility() {
            // adding the add action to the site usage table
            ctrl.siteUsageConfig.addAction = function(){
                ctrl.newSiteUsage = {id:GeneralUtilsService.getRandomId(),"name":"", siteId : -1, site : ctrl.siteUsageConfig.sites[0], region : ctrl.zoneList[0],quantity: 1};
                $scope.$root.openPopup('addSiteUsageDlg');
            };
            //this function will be called upon the dialog close of addSiteUsage
            ctrl.addSiteUsage = function() {
                for (var i = 0; i < (ctrl.newSiteUsage.site.id == -1?ctrl.newSiteUsage.quantity: 1); i++){
                    var item = angular.copy(ctrl.newSiteUsage);
                    item.id = GeneralUtilsService.getRandomId(); //creating new id to avoid duplication
                    item.expirationService = {
                        id: 'item-' + item.site,
                        getExpiration: function() {
                            return item.currentLifeCycleExpiration;
                        },
                        setExpiration: function(expiration) {
                            item.currentLifeCycleExpiration = expiration;
                        }
                    };
                    if (item.expiration != null)
                        item.currentLifeCycleExpiration = item.expiration;

                    ctrl.componentConfig.planStats.totalStats.total++;
                    item.isAllocated = (item.site.id == -1) ? false : true;
                    var attribute = (item.siteLifeCycleStatus != null) ? item.siteLifeCycleStatus.toLowerCase() : null;
                    if (item.isAllocated){
                        ctrl.componentConfig.planStats.usedStats.total++;
                        if (attribute =! null)
                            ctrl.componentConfig.planStats.usedStats[attribute]++;
                    }else{
                        ctrl.componentConfig.planStats.unusedStats.total++;
                        if (attribute =! null)
                            ctrl.componentConfig.planStats.usedStats[attribute]++;
                    }
                    ctrl.siteUsageConfig.items.push(item);
                }
                $scope.$root.closePopup('addSiteUsageDlg');
            };
        }

        /**
         * fetch the site data from the server so we could populate the used
         * sites and the dialogs
         */
        function populateSitesData() {
            // Get all sites
            store.fetch({
                path: "/sitesForPlan",
                queryParams: {'accountId': $state.params.accountId},
                method: 'POST',
                dataObj: 'dataConfig',
                data: {"limit":-1,"orders":[{"path":"name","dir":"ASC"}]},
                success: function(data) {
                    $timeout(function() {
                        ctrl.siteUsageConfig.sites = ctrl.siteUsageConfig.sites.concat(data.items);
                        if(ctrl.siteUsageConfig.items){
                            ctrl.siteUsageConfig.processData(ctrl.siteUsageConfig.items);
                        }
                    }, 0);
                }
            });
        }


        function setUnallocatedSite(item){
            if (item.siteId && item.siteId != -1){
                item.isAllocated = true;
            }
            else {
                for(var index in ctrl.siteUsageConfig.sites){
                    var site = ctrl.siteUsageConfig.sites[index];
                    if(site.id == -1){
                        item.siteId = -1;
                        item.isAllocated = false;
                        item.site = site;
                        break;
                    }
                }
            }
        }

        /**
         * return a copy of the site usage config items according to the currentLifeCycle
         * @param currentLifeCycle
         * @returns {*}
         */
        function getSiteUsageConfig() {
            return angular.copy(ctrl.siteUsageConfig.items);
        }

        init();
    }
});
